export function dontFireOnTouchEventOnTargetHandler(
  targetClassName: string,
  clickAwayFunction: () => void,
  event: Event
) {
  if (event instanceof TouchEvent) {
    const target = event.target as unknown as HTMLElement;
    const isTarget = target.classList.contains(targetClassName) ?? false;
    !isTarget ? clickAwayFunction() : null;
  } else if (event instanceof PointerEvent) {
    clickAwayFunction();
  }
  return;
}
